import { Controller } from "@hotwired/stimulus"

// Promote a child lazy turbo-frame to eager loading the first time the
// dropdown button is hovered, focused, or clicked. Used by
// `Buttons::MoreActionsDropdownComponent` when invoked with a `lazy_url:`
// so that menu items are fetched on demand rather than rendered upfront
// for every row on the page. Hover-triggering lets the request start
// before the user actually clicks, hiding most of the fetch latency.
export default class extends Controller {
  static targets = ["frame"]

  // No "already loaded" flag: a morph resets the frame to lazy and empty while
  // this controller stays connected, so a flag would leave the menu blank.
  // Re-promoting a complete frame is a no-op (Turbo skips complete frames).
  load() {
    if (!this.hasFrameTarget) return
    this.frameTarget.setAttribute("loading", "eager")
  }
}
